import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import api from '../../api/api';

interface RestaurantData {
  name: string;
  description: string;
}

const SeoUpdater = () => {
  const { restaurantId } = useParams<{ restaurantId: string }>();
  const [restaurantData, setRestaurantData] = useState<RestaurantData | null>(
    null
  );

  useEffect(() => {
    let cancelled = false;

    const fetchSeo = async () => {
      if (!restaurantId) return;
      try {
        const data = await api.CustomerRestaurant.details(restaurantId);
        if (cancelled) return;

        // API returns a full restaurant object; only take the fields we need
        setRestaurantData({
          name: data?.name ?? '',
          description: data?.description ?? '',
        });
      } catch (error) {
        if (!cancelled) {
          console.error('Error fetching restaurant data:', error);
        }
      }
    };

    fetchSeo();

    return () => {
      cancelled = true;
    };
  }, [restaurantId]);

  if (!restaurantData) {
    return null;
  }

  return (
    <Helmet>
      <title>{`${restaurantData.name} - SmartRisto`}</title>
      <meta name="description" content={restaurantData.description} />
      <meta
        property="og:title"
        content={`${restaurantData.name} - SmartRisto`}
      />
      <meta property="og:description" content={restaurantData.description} />
      <meta
        property="twitter:title"
        content={`${restaurantData.name} - SmartRisto`}
      />
      <meta
        property="twitter:description"
        content={restaurantData.description}
      />
    </Helmet>
  );
};

export default SeoUpdater;
